import classNames from "classnames";
import PropTypes from "prop-types";
import { ReactComponent as CheckIcon } from "../../Assets/icons/check.svg";
import checkboxCheckedIcon from "../../Assets/icons/checkbox_checked.svg";
import checkboxCheckedInvertedIcon from "../../Assets/icons/checkbox_checked_inverted.svg";
import checkboxUncheckedIcon from "../../Assets/icons/checkbox_unchecked.svg";

const Checkbox = ({
  label,
  subLabel,
  children,
  errors,
  touched,
  icon,
  required,
  checked,
  onChange,
  variant = "default",
  inverted = false,
  ...rest
}) => {
  const inputId = `checkbox-${
    label ? label.replace(/\s+/g, "-").toLowerCase() : "consent"
  }`;

  if (variant === "round") {
    const handleClick = () => {
      if (rest.disabled) return;
      onChange?.(!checked);
    };

    const checkedIcon = inverted
      ? checkboxCheckedInvertedIcon
      : checkboxCheckedIcon;

    return (
      <div
        className={classNames("acoris__checkbox", "acoris__checkbox--round", {
          "acoris__checkbox--round--inverted": inverted,
          "acoris__checkbox--error": touched && errors,
          "acoris__checkbox--disabled": rest.disabled,
        })}
      >
        <button
          type="button"
          className="acoris__checkbox--round-btn"
          onClick={handleClick}
          disabled={rest.disabled}
          aria-checked={checked}
          role="checkbox"
        >
          <img
            src={checked ? checkedIcon : checkboxUncheckedIcon}
            alt=""
            className="acoris__checkbox--round-icon"
          />
        </button>
        <button
          type="button"
          className="acoris__checkbox--text"
          onClick={handleClick}
          disabled={rest.disabled}
        >
          {children || label}
        </button>
      </div>
    );
  }

  // Madelin variant with children (special style for self-employed)
  if (variant === "madelin") {
    const handleClick = () => {
      if (onChange) {
        onChange(!checked);
      }
    };

    return (
      <div className="acoris__checkbox acoris__checkbox--madelin">
        <button
          type="button"
          className={classNames("acoris__checkbox--box", {
            "acoris__checkbox--box--checked": checked,
          })}
          onClick={handleClick}
        >
          {checked && <CheckIcon />}
        </button>
        <div className="acoris__checkbox--text" onClick={handleClick}>
          {children || label}
        </div>
      </div>
    );
  }

  // Consent variant with children
  if (variant === "consent" || children) {
    const handleClick = () => {
      if (onChange) {
        onChange(!checked);
      }
    };

    return (
      <div className="acoris__checkbox acoris__checkbox--consent">
        <button
          type="button"
          className={classNames("acoris__checkbox--box", {
            "acoris__checkbox--box--checked": checked,
          })}
          onClick={handleClick}
        >
          {checked && <CheckIcon />}
        </button>
        <div className="acoris__checkbox--text" onClick={handleClick}>
          {children || label}
        </div>
      </div>
    );
  }

  // Default checkbox variant
  return (
    <label
      className={classNames("acoris__checkbox", {
        "acoris__checkbox--error": touched && errors,
      })}
      htmlFor={inputId}
    >
      <input
        id={inputId}
        type="checkbox"
        className={classNames({ "disable--input": rest.disabled })}
        checked={checked}
        onChange={(e) => onChange && onChange(e.target.checked)}
        {...rest}
      />
      <div className="acoris__checkbox--label">
        <div className="acoris__checkbox--label--text">{label}</div>
        {subLabel && (
          <div className="acoris__checkbox--label--subLabel">{subLabel}</div>
        )}
      </div>
    </label>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string,
  subLabel: PropTypes.string,
  children: PropTypes.node,
  variant: PropTypes.oneOf(["default", "consent", "madelin", "round"]),
  inverted: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};

Checkbox.defaultProps = {
  label: "",
  subLabel: "",
  variant: "default",
  inverted: false,
};

export default Checkbox;
